import angular from 'angular';
import { ServicesModule } from '../../services/services.module';
import { AccountRouting } from './account.routing';

export const AccountModule = 'mandaeApp.account';

angular.module(AccountModule, [
  'ui.router',
  ServicesModule,
])
.config(AccountRouting)
